export const metalStreamDataHelper = (object, key) => {
  if (!object) {
    return null;
  }

  if (key === 'GoldPercentage') {
    return Math.round(100 * object[key]);
  }

  if (key === 'SilverPercentage') {
    return Math.round(100 * object[key]);
  }

  return object[key];
};
